






















































import Vue, { PropOptions } from 'vue'
import { Tab as TabProps } from '../interfaces'
import Subtab from '../components/Subtab.vue'
import Loader from '@/components/Loader.vue'

import { Subtab as SubtabProps } from '../interfaces'

interface Data {
  isHovered: boolean
  isTransitioning: boolean
}

interface Methods {
  handleTabClick(): void
  handleHoverStart(): void
  handleHoverEnd(): void
}

interface BackgroundStyle {
  background: string
  transform: string
}

interface Computed {
  backgroundStyle: BackgroundStyle
  isSubtabsDisabled: boolean
}

interface Props {
  tab: TabProps
  isActive: boolean
  currentSubtab: string
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'tab',
  data: () => ({
    isHovered: false,
    isTransitioning: false,
  }),
  components: { Subtab, Loader },
  props: {
    tab: {
      type: Object,
      default: () => null,
    } as PropOptions<TabProps>,
    isActive: {
      type: Boolean,
      default: () => false,
    },
    currentSubtab: {
      type: String,
      default: () => '',
    },
  },
  computed: {
    backgroundStyle: function() {
      const position = this.isActive ? -100 : 0
      return {
        background: this.tab.color,
        transform: `translate3d(0px, ${position}%, 0)`,
      }
    },
    isSubtabsDisabled(): boolean {
      // Subtabs needed to be disabled at one point.
      // Maybe we'll leave this here in case there's another reason we need to disable them in the future
      return false
    },
  },
  methods: {
    handleTabClick() {
      this.isTransitioning = this.isActive ? false : true
      // If we dont timeout IE doesnt actually show the transition loader, which is the whole point of having it
      setTimeout(() => {
        this.$emit('click')
      })
    },
    handleHoverStart() {
      this.isHovered = true
    },
    handleHoverEnd() {
      this.isHovered = false
    },
  },
  watch: {
    $route(to, from) {
      this.isTransitioning = false
    },
  },
})
